// Builder.io Configuration
// Get your API key from: https://builder.io/account/settings

export const BUILDER_API_KEY =
  process.env.REACT_APP_BUILDER_API_KEY || '9440a5639fd34ae1aac06e1e92706bdb';

// Model names for different content types
export const BUILDER_MODELS = {
  page: 'page',
  section: 'section',
  component: 'component',
} as const;

export const BUILDER_FIGMA_MODEL = 'figma-imports';

/** Published Builder.io page entries (figma-imports / page models). */
export const BUILDER_CONTENT_IDS = {
  aboutUs: 'fbcba901947441d6800ad27bd73aacad',
} as const;

/** Builder block ids to hide when embedded chrome duplicates the app shell. */
export const BUILDER_HIDDEN_BLOCKS = {
  aboutUsNavBar: 'builder-e759fb901ac640f380a74b25f0570d90',
} as const;

export const BUILDER_ABOUT_US_HIDDEN_BLOCKS = [BUILDER_HIDDEN_BLOCKS.aboutUsNavBar] as const;

/** Footer "About us" text blocks — published without links in Builder.io. */
export const BUILDER_FOOTER_ABOUT_US_BLOCK_IDS = [
  'builder-bb9797cf014e4ad8a0a4b36a6754b6e2', // desktop
  'builder-2d291555894d4f7fac98ff90a539d368', // tablet
  'builder-05a9a9f75c25405cbd0dd2545f971aa0', // mobile
] as const;

/** Investor landing — /myinvestor (Desktop - Investor) */
export const BUILDER_INVESTOR_PAGE_URL = '/myinvestor';

/** Startup landing — https://www.builder.my/startup */
export const BUILDER_STARTUP_PAGE_URL = '/startup';

/** Investor FAQ page — model: "page", url: /investorinvestors-faq */
export const BUILDER_INVESTOR_FAQ_URL = '/investorinvestors-faq';
